<template>
  <OrderItemBlock
    :imageUrl="imageUrl"
    :imageAlt="name"
    :name="name"
    :descriptionLines="descriptionLines"
    :sizeModifier="sizeModifier"
    :quantity="quantity"
    :isQuantityVisible="false"
    :price="price"
    :recurringPriceText="$t('monthly')"
    :productPath="productPath"
    :isMerging="isMerging"
    :isTransitioning="isTransitioning"
    :isReadOnly="isReadOnly"
    :isHidden="isHidden"
    :isRemoved="isRemoved"
    :contextMessage="$t('subscription')"
    v-data-test-id="'subscription-order-item'"
    @remove-item="removeItem"
  />
</template>

<script>
import OrderItemBlock, { SIZE_MODIFIERS } from './OrderItemBlock.vue'

export { SIZE_MODIFIERS }

export default {
  name: 'RegularOrderItem',
  components: {
    OrderItemBlock,
  },

  props: {
    id: { type: Number, required: true },
    name: { type: String, required: true },
    imageUrl: { type: String, required: true },
    productPath: { type: String, default: '#' },
    descriptionLines: { type: Array },
    price: { type: Number, required: true },
    quantity: { type: Number, default: 1, required: true },
    isMerging: { type: Boolean },
    isTransitioning: { type: Boolean },
    isHidden: { type: Boolean },
    isRemoved: { type: Boolean },
    isReadOnly: { type: Boolean },
    sizeModifier: { type: String },
  },

  methods: {
    removeItem(element) {
      this.$emit('remove-item', element)
    },
  },
}
</script>

<i18n src="@/locales/subscription_order_item.json" />
